import type {UnmappedReportData} from 'shells/utils/hooks/use-get-bucketed-report-data';

export const mapBucketsFunction = (data: UnmappedReportData) => ({
    bucket: data.bucket,
    count: data.count.value,
});
